const defaultProps = {
  variant: 'determinate',
};

export default defaultProps;
